var $ = require("jquery");
import { isLargeNonTouchDevice } from './libs/gsap/globals.js';

if ($('body.home').length && isLargeNonTouchDevice()) {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  window.addEventListener('beforeunload', () => {
    window.scrollTo(0, 0);
  });

  window.scrollTo(0, 0);

  window.addEventListener('load', () => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 1);
  });
}

import './libs/gsap/hp-splash.js';
import './libs/gsap/hp-about.js';
import './libs/gsap/hp-latest-news.js';
import './libs/gsap/pinned-slider.js';
import './libs/gsap/product-frames.js';
